import { Injectable } from '@angular/core';
import { HttpFunctionsService } from '../http-services/http-functions.service';
import { catchError, map, throwError } from 'rxjs';
import { AnalyticsObj } from 'src/app/models/producer-analytics.model';

export enum ANALYTICS_ENUMS {
  beatsPlayed = 'beatPlays',
  mp3Downloads = 'mp3Downloads',
  beatsInCart = 'beatsInCart',
  grossSales =  'grossSales',
  earnings =  'earnings',
  analyticsKpi= "kpi",
  ANALYTICS_LICENCE_INFO = "licenceInfo",
  ANALYTICS_TOP_STREAMING = "topStreaming"
}
@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  authBaseUrl:string = 'producer/';
  excelFileData: Array<any> = [];
  constructor(private httpService: HttpFunctionsService) { }

  prepareAnalyticsData(responseData: any) {
    let analyticsList: Array<AnalyticsObj> = [];
    analyticsList.push({
      title : "Active Beats",
      value: responseData?.activeBeats,
      iconName:"all-beat-icon.png",
      backgroundColor: "#242424",
      accessType: ['tier0', 'tier1', 'tier2'],
      isShow: false
    },
    {
      title : "Total Orders",
      value: responseData?.totalOrders,
      iconName:"store-icon.png",
      backgroundColor: "#242424",
      accessType: ['tier0', 'tier1', 'tier2'],
      isShow: false
    },
    {
    title : "Beats Sold",
    value: responseData.beatsSold,
    iconName:"sold-beats-icon.png",
    backgroundColor: "#242424",
    accessType: ['tier0', 'tier1', 'tier2'],
    isShow: false
    },
    {
      title : "Total Earnings",
      value: responseData.earnings,
      iconName:"",
      backgroundColor: "#242424",
      accessType: ['tier0', 'tier1', 'tier2'],
      isShow: false
    },
    {
      title : "Total MP3 downloads",
      value: responseData.totalDownloads,
      iconName:"download-icon.png",
      backgroundColor: "#18213F",
      accessType: ['tier1', 'tier2'],
      isShow: false
    },
    {
      title : "Total Liked Beats",
      value: responseData.totalLikes,
      iconName:"hearts-icon.png",
      backgroundColor: "#18213F",
      accessType: ['tier1', 'tier2'],
      isShow: false
    },
    {
      title : "Total Plays",
      value: responseData.totalPlays,
      iconName:"Play.png",
      backgroundColor: "#18213F",
      accessType: ['tier1', 'tier2'],
      isShow: false
    },
    {
      title : "Gross Sales",
      value: responseData.grossSales,
      iconName:"",
      backgroundColor: "#18213F",
      accessType: ['tier1', 'tier2'],
      isShow: false
    },
    {
      title : "Total Beats in Cart",
      value: responseData.beatsInCart,
      iconName:"cart-icon.png",
      backgroundColor: "#29183F",
      accessType: ['tier1', 'tier2'],
      isShow: false
    },
    {
      title : "Genre with most plays",
      value: responseData.genreWithMaxPlays,
      iconName:"target-icon.png",
      backgroundColor: "#29183F",
      accessType: ['tier1', 'tier2'],
      isShow: false
    },
    {
      title : "Total Discount Given",
      value: responseData.totalDiscountGiven.toFixed(1),
      iconName:"",
      backgroundColor: "#29183F",
      accessType: ['tier1', 'tier2'],
      isShow: false
    },
    {
      title : "Average Order Value",
      value: (responseData.grossSales /responseData?.totalOrders).toFixed(1),
      iconName:"",
      backgroundColor: "#29183F",
      accessType: ['tier1', 'tier2'],
      isShow: false
    })
    return analyticsList;
  }

  /**
   * In this function getting of chart according to number of days
   * @param numberOFDays  Number on days
   * @param objectName : Key Name  which type of tab data needed
   * @returns 
   */
  getChartAnalyticsData(numberOFDays: number, objectName: string = "", isShowMainLoader: boolean = true) {
    return this.httpService.getMethod(`user/analytics?days=${numberOFDays}&q=${objectName}`, isShowMainLoader).pipe(map((response: any) => {
      let selectedKeyData: any = "";
      if (objectName) {
        if (objectName === 'beatsPlayed') {
          selectedKeyData = this.getPrepareDataAnalytics(response[ANALYTICS_ENUMS.beatsPlayed],ANALYTICS_ENUMS.beatsPlayed, 'playCount');
        } else if (objectName === 'mp3Downloads') {
          this.setExcelFileData(response.consolidated, "mp3Downloads");
          selectedKeyData = this.getPrepareDataAnalytics(response[ANALYTICS_ENUMS.mp3Downloads],ANALYTICS_ENUMS.mp3Downloads,'downloadCount');
        } else if (objectName === 'grossSales'){
          selectedKeyData = this.getPrepareDataAnalytics(response[ANALYTICS_ENUMS.grossSales],ANALYTICS_ENUMS.grossSales);
        } else if (objectName === 'earnings'){
          selectedKeyData = this.getPrepareDataAnalytics(response[ANALYTICS_ENUMS.earnings],ANALYTICS_ENUMS.earnings);
        } else if (objectName === 'kpi' ){
          selectedKeyData = this.prepareAnalyticsData(response[ANALYTICS_ENUMS.analyticsKpi]);
        } else if (objectName === 'beatsInCart') {
          this.setExcelFileData(response[ANALYTICS_ENUMS.beatsInCart], "beatsInCart");
          selectedKeyData = this.getPrepareDataAnalytics(response[ANALYTICS_ENUMS.beatsInCart], ANALYTICS_ENUMS.beatsInCart);
        } else if (objectName === 'licenceInfo') {
          selectedKeyData = this.getPrepareDataAnalytics(response[ANALYTICS_ENUMS.ANALYTICS_LICENCE_INFO], ANALYTICS_ENUMS.ANALYTICS_LICENCE_INFO)
        }  else  {
          selectedKeyData = this.getPrepareDataAnalytics(response[ANALYTICS_ENUMS.ANALYTICS_TOP_STREAMING], ANALYTICS_ENUMS.ANALYTICS_TOP_STREAMING);
        }
      }
      return  selectedKeyData;
    }), catchError((error: any) => {
      return throwError(error);
  }));
  }

  getPrepareDataAnalytics(responseData: any, keyName: string, countKeyName: string = "") {
    let prepareChartArray: Array<any> = []; 
    if (responseData && typeof(responseData) === 'object' &&  Object.keys(responseData).length > 0) {
        let  keysList =  Object.keys(responseData);
        if (keyName === 'beatPlays' || keyName === 'mp3Downloads' ||  keyName === 'beatsInCart') {
          keysList.map((key: any) => {
            if (responseData[key] &&  typeof(responseData[key]) === 'object' &&  Object.keys(responseData[key]).length > 0) {
              let subList: any = responseData[key];
              let object:any = {};
              let subKeysList: any = Object.keys(subList);
              let sums = 0;
              if (keyName === "beatsInCart") {
                object = responseData[key][0];
                object['serial_number'] = key;
                object['isLock'] =  false;
                object["numberOfCount"] = responseData[key].length;
              } else {
                subKeysList.map((subKeys: any) => {
                  let  subsObject: any = subList[subKeys];
                  sums += subsObject[countKeyName];
                });
                object['count'] =  sums;
                object['date'] =  key;
              }
              prepareChartArray.push(object);
            }
          });
          if (keyName !== "beatsInCart") {
            if (this.isCheckEmptyData(prepareChartArray)) {
              prepareChartArray = [];
            }
          }
        } else if (keyName === 'grossSales' || keyName === 'earnings'){
          keysList.map((key: any) => { 
            let object:any = {};
            object['count'] =  responseData[key];
            object['date'] =  key;
            object['isLock'] =  false;
            prepareChartArray.push(object);
          });
          if (this.isCheckEmptyData(prepareChartArray)) {
            prepareChartArray = [];
          }
        } else if (keyName ===  'licenceInfo') {
          keysList.map((key: any) => {
            if (responseData[key] &&  typeof(responseData[key]) === 'object' &&  Object.keys(responseData[key]).length > 0) { 
              prepareChartArray.push(responseData[key]);
            }
          });
        } else {
          let object:any = {};
          keysList.map((key: any) => { 
            object = responseData[key];
            object['serial_number'] = key;
            object['isLock'] =  false;
            prepareChartArray.push(object);
          });
        }
        if (keyName !== "beatsInCart" &&  keyName !== "topStreaming" && keyName !==  'licenceInfo') {
          prepareChartArray = this.sortArrayByDate(prepareChartArray);
        }
        if (keyName === "topStreaming") {
          prepareChartArray = this.sortArrayByLastPlayed(prepareChartArray);
          let topStreamingFinalArray: any = prepareChartArray;
          prepareChartArray = [];
          topStreamingFinalArray.map((item: any, index: number) => {
            if (index <  10) {
              prepareChartArray.push(item);
            }
          })
        }
    }
    return prepareChartArray;
  }

  sortArrayByDate(arrayList: any): Array<any> {
    let sortedList: Array<any> = [];
    if (arrayList) {
      sortedList = arrayList.sort((a: any,b: any) => {
        a =  new Date(a.date).getTime();
        b = new Date(b.date).getTime();
        return a - b ;
      });
    }
    return sortedList;
  }

  sortArrayByLastPlayed(arrayList: any): Array<any> {
    let sortedList: Array<any> = [];
    if (arrayList) {
      sortedList = arrayList.sort((a: any,b: any) => {
        a = a.playCount;
        b = b.playCount;
        return b - a ;
      });
    }
    return sortedList;
  }

  isCheckEmptyData(prepareChartArray: any): boolean {
    return prepareChartArray.every((item: any) =>  item.count === 0);
  }

  setExcelFileData(responseData: any, type: string){
    this.excelFileData = [];
    if (type === "beatsInCart") {
      let keyList: any =  Object.keys(responseData);
      if (keyList &&  keyList.length) {
        keyList.map((key: string) => {
          let beatList: any = responseData[key];
          if (beatList &&  beatList.length > 0) {
            beatList.map((beatData: any) => {
              let obj : any = {};
              obj['Beat Title'] = beatData?.beat?.title;
              obj['User Email Address'] = beatData?.user?.email;
              obj['License Type'] = beatData.beat_price.licence.title;
              obj['License Fee'] = "₹"+beatData.beat_price.final_price;
              this.excelFileData.push(obj);
            });
          }
        })
      }
    } else {
      responseData.map((item: any) => {
        let downloadEmailArray: any = item.downloaderEmail;
        if (downloadEmailArray &&  downloadEmailArray.length) {
          downloadEmailArray.map((emailData: any) => {
            let obj: any = {}
            obj['Beat Title'] = item.title;
            obj['User Email Address'] = emailData;
            this.excelFileData.push(obj);
          });
        }
      })
    }
  }

}
